module.exports = __webpack_public_path__ + "static/media/sao-goncalo.b0f44dcc.jpg";